import { getStore } from '../store/Store';
import isMailComposeActiveWithReadingPaneOff from './isMailComposeActiveWithReadingPaneOff';

/**
 * Returns a flag indicating whether to show list view or not
 */
export function shouldShowListView(): boolean {
    return !isMailComposeActiveWithReadingPaneOff() && getStore().showListPane;
}
